import { RouteObject } from "../../interfaces/navigation";
import React from "react";
import CongratulationsPage from "../CongratulationsPage";

const RegisterRedirect = React.lazy(() => import("./RegisterRedirect"));

export const registerRoutes: RouteObject[] = [
    {
        title: "Register",
        path: "/registro",
        component: <RegisterRedirect/>
    },
    {
        title: "Congratulations",
        path: "/registro/agradecimiento",
        component: <CongratulationsPage title={"Ya eres parte de Linze."} text={"Encuentra tu próximo auto o publica el tuyo con solo un par de clics. ¡Un nuevo camino te espera!"} />
    }
];